import { render, staticRenderFns } from "./ListaDocumentosDetalhes.vue?vue&type=template&id=5b3f80ac&scoped=true&"
import script from "./ListaDocumentosDetalhes.vue?vue&type=script&lang=js&"
export * from "./ListaDocumentosDetalhes.vue?vue&type=script&lang=js&"
import style0 from "./ListaDocumentosDetalhes.vue?vue&type=style&index=0&id=5b3f80ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3f80ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VDivider,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VSubheader})
